import { notification } from 'antd';
import { useState } from 'react';
import { useDeleteEducationClassMutation } from 'shared/api';
import type { EducationClass } from 'shared/api';

export const useDeleteEducationClass = (selectedEducationClass: EducationClass) => {
  const [deleteEducationClass, { isLoading }] = useDeleteEducationClassMutation();

  const [visible, setVisible] = useState(false);

  const onSubmit = async () => {
    await deleteEducationClass(selectedEducationClass!.id)
      .then(() => {
        hideModal();
      })
      .catch((error) => {
        notification.error({ message: 'Не удалось удалить класс', description: error.message });
        throw error;
      });
  };

  const showModal = () => setVisible(true);

  const hideModal = () => {
    setVisible(false);
  };

  return {
    state: {
      isLoading,
      visible,
    },
    methods: {
      onSubmit,
      showModal,
      hideModal,
    },
  };
};
